import {useState, useEffect} from 'react'
import {camelizeKeys} from 'humps'

import {useRails} from '~/react/contexts/rails'
import {fetcher} from '~/api'

export const useActivities = (params) => {
  const {
    organisation: {currentSupplier},
  } = useRails()

  const [activities, setActivities] = useState([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  const perPage = params?.perPage || 100

  const searchParams = new URLSearchParams()

  searchParams.append('per_page', perPage)

  const query = searchParams.toString()

  useEffect(() => {
    const fetchActivities = async () => {
      try {
        setLoading(true)
        setError(null)

        const path = `/points/api/suppliers/${currentSupplier.id}/activities`

        const url = `${path}?${query}`

        const response = await fetcher(url)

        const processedData = camelizeKeys(response, {deep: true})

        const transformedActivities = (processedData.activities || []).map(
          (activity) => ({
            ...activity,
            mCoinsTransaction: {
              amount: activity.pointsAmount,
              type: activity.transactionType,
            },
          }),
        )

        setActivities(transformedActivities)
      } catch (err) {
        setError(err)
      } finally {
        setLoading(false)
      }
    }

    fetchActivities()
  }, [currentSupplier.id, query])

  if (error) {
    throw error
  }

  return {
    activities,
    loading,
  }
}
